import { Navigate, useRoutes } from 'react-router-dom';
// 
import GuestGuard from '../context/GuestGuard';
import AuthGuard from '../context/AuthGuard';
// layouts
import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
import CommerceLayout from '../layouts/main/CommerceLayout';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// context
import { BshopProvider } from '../context/BshopContext';
// config
import { PATH_AFTER_LOGIN } from '../config';
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,
  ResendCode,
  //
  Page500,
  Page403,
  Page404,
  HomePage,
  FaqsPage,
  AboutPage,
  BenefitPage,
  FuncionalityPage,
  AgrolabStamp,
  Contact,
  PricingPage,
  MaintenancePage,
  ComingSoonPage,
  EcommerceAllShopPage,
  EcommerceShopPage,
  EcommerceProductDetailsPage,
  EcommerceCheckoutPage,
  // MY PROFILE
  UserAccountPage,
  InvoiceListPage,
  OrderDetails
} from './elements';

export default function Router() {
  return useRoutes([
    // Main Routes
    {
      element: <MainLayout />,
      children: [
        { element: <HomePage />, index: true },
        { path: 'e-commerce', element: <EcommerceAllShopPage /> },
        { path: 'about-us', element: <AboutPage /> },
        { path: 'benefit', element: <BenefitPage /> },
        { path: 'funcionality', element: <FuncionalityPage /> },
        { path: 'agrolabStamp', element: <AgrolabStamp /> },
        { path: 'contact-us', element: <Contact /> },
        { path: 'faqs', element: <FaqsPage /> },
      ]
    },
     // Auth
     {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
            {path: 'resend-code', element: <ResendCode />}
          ],
        },
      ],
    },
    // MY ACCOUNT
    {
      path: 'myAccount',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'account', element: <UserAccountPage /> },
        { path: 'purchased/list', element: <InvoiceListPage /> },
        { path: 'purchased/:orderNumber/view', element: <OrderDetails /> },
      ]
    },
    // E-Commerce
    {
      element: <BshopProvider><CommerceLayout /></BshopProvider>,
      children: [
        { element: <HomePage />, index: true },
        { path: 'e-commerce/:bshopId', element: <EcommerceShopPage /> },
        { path: 'e-commerce/product/:id', element: <EcommerceProductDetailsPage /> },
        { path: 'e-commerce/checkout', element: <EcommerceCheckoutPage /> },
      ]
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: 'pricing', element: <PricingPage /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
